import React, { useEffect, useState } from "react";
import { TValidCardAttachment } from ".";
import { Trello } from "../../../external/trello-pu__core/trello-iframe/trello";
import { useTrelloPowerUpContext } from "../../../external/trello-pu__core/trello-iframe/context";
// import isLocalStorageAvailable from "../../../external/trello-pu__core/utils/local-storage-helper";
// import trelloAlerts from "../../strings/trello-alerts";
import ConditionalRender from "../shared/components/conditional-renderer";
// import { Trello } from '../../../@types/my-trello-types';
// import ConditionalRender from '../../modal/utils/conditional-renderer';
// import isLocalStorageAvailable from '../../shared/local-storage-helper';
// import trelloIFrame from '../../shared/trello-client/trello-iframe';
import UnavailableCardsList from "./cards-group-list/removed-cards-list/_unavailable-cards-list";
import ValidCardsList from "./cards-group-list/valid-cards-list/valid-cards-list";
import { css } from "@emotion/react";
import isLocalStorageAvailable from "../../../external/trello-pu__core/utils/local-storage-helper";
// import trelloAlerts from '../../../../config/trello-alerts';

type TProps = {
  boardsWithTargets: string[];
  validCards: TValidCardAttachment[];
  removedCardsAttachments: Trello.Attachment[];
  unauthorizedToViewCards: Trello.Attachment[];
  shortLinkCurrentCard: string;
  onConnectCardsRequest(idTargetCard: string): void;
  onRemoveAttachmentRequest(idAttachment: string): void;
};

function CardsGroupsList(props: TProps) {
  const { trelloIFrame } = useTrelloPowerUpContext();
  const [collapsedBoardsIds, setCollapsedBoardsIds] = useState<string[]>([]);

  const TRELLO_STORAGE_KEY = "collapsed_boards_on_card";
  const COLLAPSED_BOARDS__LS_KEY = `links_pup:collapsed_boards_on_card-${
    trelloIFrame.getContext().card
  }`;

  useEffect(() => {
    if (isLocalStorageAvailable()) {
      setCollapsedBoardsIds(
        JSON.parse(localStorage.getItem(COLLAPSED_BOARDS__LS_KEY) ?? "[]")
      );
    } else {
      trelloIFrame
        .get("card", "private", TRELLO_STORAGE_KEY, [])
        .then(setCollapsedBoardsIds);
    }
  }, [trelloIFrame, TRELLO_STORAGE_KEY, COLLAPSED_BOARDS__LS_KEY]);

  useEffect(() => {
    if (isLocalStorageAvailable()) {
      localStorage.setItem(
        COLLAPSED_BOARDS__LS_KEY,
        JSON.stringify(collapsedBoardsIds)
      );
    } else {
      trelloIFrame.set(
        "card",
        "private",
        TRELLO_STORAGE_KEY,
        collapsedBoardsIds
      );
    }
    trelloIFrame.sizeTo("#attachment-section-root");
  }, [
    collapsedBoardsIds,
    TRELLO_STORAGE_KEY,
    COLLAPSED_BOARDS__LS_KEY,
    trelloIFrame,
  ]);

  function onGroupCollapsedToggleHandler(idBoard: string) {
    if (collapsedBoardsIds.includes(idBoard)) {
      setCollapsedBoardsIds((prev) => prev.filter((id) => id !== idBoard));
    } else {
      setCollapsedBoardsIds((prev) => prev.concat([idBoard]));
    }
  }

  return (
    <ul
      css={css`
        min-height: 200px;
      `}
    >
      <ValidCardsList
        cards={props.validCards}
        boardsWithTargets={props.boardsWithTargets}
        shortLinkCurrentCard={props.shortLinkCurrentCard}
        collapsedBoardsIds={collapsedBoardsIds}
        onConnectClick={props.onConnectCardsRequest}
        onRemoveClick={props.onRemoveAttachmentRequest}
        onGroupCollapsedToggle={onGroupCollapsedToggleHandler}
      />
      <ConditionalRender
        condition1={props.removedCardsAttachments.length > 0}
        renderIf1True={
          <UnavailableCardsList
            cards={props.removedCardsAttachments}
            shortLinkCurrentCard={props.shortLinkCurrentCard}
            onRemoveClick={props.onRemoveAttachmentRequest}
            isCollapsed={collapsedBoardsIds.includes("0")} //id for the removed cards group will be '0'
            onGroupCollapsedToggle={() => onGroupCollapsedToggleHandler("0")}
            mode={"removed"}
          />
        }
      />
      <ConditionalRender
        condition1={props.unauthorizedToViewCards.length > 0}
        renderIf1True={
          <UnavailableCardsList
            cards={props.unauthorizedToViewCards}
            shortLinkCurrentCard={props.shortLinkCurrentCard}
            onRemoveClick={props.onRemoveAttachmentRequest}
            isCollapsed={collapsedBoardsIds.includes("-1")} //id for the unauthorized cards group will be '-1'
            onGroupCollapsedToggle={() => onGroupCollapsedToggleHandler("-1")}
            mode={"unauthorized"}
          />
        }
      />
    </ul>
  );
}

export default CardsGroupsList;
